import {
  createStore, combineReducers, applyMiddleware, compose,
} from 'redux';
import { i18nReducer } from 'react-redux-i18n';
import thunk from 'redux-thunk';

import activitiesReducer from './reducers/activities';
import authReducer from './reducers/auth';
import settingsReducer from './reducers/settings';
import loadingReducer from './reducers/loading';
import categoriesReducer from './reducers/categories';
import productsReducer from './reducers/products';
import brandsReducer from './reducers/brands';
import clientsReducer from './reducers/clients';
import accessProfileReducer from './reducers/accessProfile';
import promotionsReducer from './reducers/promotions';
import recommendedsReducer from './reducers/recommendeds';
import ordersReducer from './reducers/orders';
import solicitationReducer from './reducers/solicitations';
import newRegistersReducer from './reducers/newRegisters';
import usersReducer from './reducers/users';
import bannersReducer from './reducers/banners';
import manufacturersReducer from './reducers/manufacturers';
import featuredManufacturerReducer from './reducers/featuredManufacturer';
import adminUsersReducer from './reducers/adminUsers';
import punchOutRulesReducer from './reducers/punchOutRules';
import punchOutN2RulesReducer from './reducers/punchOutN2Rules';
import admMenusReducer from './reducers/admMenus';
import placesReducer from './reducers/places';
import familiesReducer from './reducers/categoryFamilies';
import notificationEmailReducer from './reducers/notificationEmail';
import abandonedReducer from './reducers/abandoned';
import overdueClientsReducer from './reducers/overdueClients';
import leadTimesReducer from './reducers/leadTime';
import branchManager from './reducers/branchManager';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default () => {
  const store = createStore(
    combineReducers({
      activities: activitiesReducer,
      auth: authReducer,
      settings: settingsReducer,
      loading: loadingReducer,
      categories: categoriesReducer,
      products: productsReducer,
      brands: brandsReducer,
      clients: clientsReducer,
      accessProfiles: accessProfileReducer,
      places: placesReducer,
      promotions: promotionsReducer,
      recommendeds: recommendedsReducer,
      orders: ordersReducer,
      solicitations: solicitationReducer,
      newRegisters: newRegistersReducer,
      users: usersReducer,
      banners: bannersReducer,
      manufacturers: manufacturersReducer,
      featuredManufacturer: featuredManufacturerReducer,
      i18n: i18nReducer,
      adminUsers: adminUsersReducer,
      punchOutRules: punchOutRulesReducer,
      punchOutN2Rules: punchOutN2RulesReducer,
      admMenus: admMenusReducer,
      families: familiesReducer,
      notificationEmail: notificationEmailReducer,
      abandonedItems: abandonedReducer,
      overdueClients: overdueClientsReducer,
      leadTimes: leadTimesReducer,
      branchManager: branchManager,
    }),
    composeEnhancers(applyMiddleware(thunk)),
  );

  return store;
};
